import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * PublicRoute - For pages that should only be shown to non-authenticated users
 * Redirects authenticated users to the dashboard.
 *
 * EXCEPTION: the marketing homepage ("/") always renders, regardless of
 * auth state. A logged-in user landing on hibff.com should see the
 * marketing page (with sign-in CTAs that take them to their dashboard) —
 * not be silently teleported. Only /login and /register auto-redirect
 * authenticated users.
 */
const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const isHomepage = pathname === '/' || pathname === '';

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Auth-gated public pages (e.g. /login, /register) bounce signed-in
  // users to the dashboard. Homepage NEVER redirects.
  if (user && !isHomepage) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;
